/* unplugin-vue-components disabled */import script from "./BannerConfigure.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerConfigure.vue?vue&type=script&setup=true&lang=js"

import "./BannerConfigure.vue?vue&type=style&index=0&id=2c746d06&lang=scss"

const __exports__ = script;

export default __exports__